<template>
  <vs-popup
    id="grand-union"
    :active.sync="enabledGrandUnion"
    @close="enabledGrandUnion = true"
    title=""
  >
    <GrandUnionFields
      :decoded="decoded"
      @selectPercentagem="onSubmitPercentagem"
    />
  </vs-popup>
</template>

<script>
import GrandUnionFields from '../../components/GrandUnionFields';
import service from '../../services';

export default {
  name: 'ModalGrandUnion',

  components: {
    GrandUnionFields,
  },

  props: ['decoded'],

  data() {
    return {
      enabledGrandUnion: false,
    };
  },

  beforeMount() {
    this.showModal();
  },

  methods: {
    async showModal() {
      const { aplicaContribuicao } = await this.buscaConfigEmpresa();
      const { valorContribuicao } = await this.getUsuario();
      const { consultor } = this.decoded;

      const verifyIfGrandUnionModal = !(
        aplicaContribuicao &&
        consultor &&
        !valorContribuicao
      );

      if (verifyIfGrandUnionModal) {
        this.enabledGrandUnion = false;
        return;
      }

      this.enabledGrandUnion = true;
    },

    onSubmitPercentagem({ customPercentage }) {
      const MINIMUM_CONTRIBUTION = 3;
      if (customPercentage < MINIMUM_CONTRIBUTION) {
        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: 'Valor mínimo: 3%.',
          color: 'danger',
        });
        return;
      }
      this.submitToServer(customPercentage);
    },
    async submitToServer(customPercentage) {
      try {
        const model = 'Usuario';
        const action = 'atualizar-usuario-grand-union';
        const objSend = {
          idEmpresa: this.decoded.id_empresa,
          idUsuario: this.decoded.id_usuario,
          valorContribuicao: Number(customPercentage),
        };

        await service.post(model, action, objSend);

        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: 'Operação realizada com sucesso.',
          color: 'success',
        });
        this.enabledGrandUnion = false;
      } catch (error) {
        this.$vs.notify({
          position: 'top-center',
          title: 'Erro',
          text: 'Ocorreu um erro durante a operação.',
          color: 'danger',
        });
      }
    },

    async buscaConfigEmpresa() {
      try {
        const model = 'g';
        const action = 'empresas/list/idEmpresa/';
        this.$vs.loading();
        const response = await service.getAll(
          model,
          {},
          action + this.decoded.id_empresa,
        );

        const hasNoData = !response.data || response.data.length === 0;

        if (hasNoData) {
          return null;
        }

        this.$vs.loading.close();
        return response.data[0];
      } catch (error) {
        this.$vs.loading.close();
        console.error('Erro durante a buscaConfigEmpresa:', error);
        throw error;
      }
    },

    async getUsuario() {
      const { id_empresa, userName, id_setor, id_usuario } = this.decoded;

      try {
        const model = 'Usuario';
        const action = 'buscarUsuario';
        const payload = {
          idEmpresa: id_empresa,
          userName,
          idSetor: id_setor,
          idUsuario: id_usuario,
        };

        const response = await service.post(model, action, payload);

        const hasNoResponse = !response.data || response.data.length === 0;

        if (hasNoResponse) {
          return null;
        }

        return response.data[0];
      } catch (error) {
        console.error('Erro ao buscar usuário:', error);
      } finally {
        this.$vs.loading.close();
      }
    },
  },
};
</script>

<style lang="css">
#grand-union .vs-popup--header {
  display: none;
}

#grand-union .vs-popup--content {
  padding: 2rem;
  margin: 0;
  border-radius: 8px;
  width: 100%;
}
</style>
